import { type ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export function ComunicadosListSkeleton(): ReactNode {
  return (
    <div className="max-h-[calc(100dvh-12rem)] space-y-sm overflow-hidden">
      {Array.from({ length: 12 }, (_, i) => (
        <Skeleton key={i} className="h-14 w-full rounded-lg" />
      ))}
    </div>
  );
}
